// extracted by mini-css-extract-plugin
export default {"container":"gray_container__CEJ2W","font":"gray_font__XaGbK","borderBottom":"gray_borderBottom__7TH+L","borderTop":"gray_borderTop__fTmlL","button":"gray_button__RXrVX"};